import { render, staticRenderFns } from "./itemPanelList.vue?vue&type=template&id=4f52d72d&scoped=true&"
var script = {}
import style0 from "./itemPanelList.vue?vue&type=style&index=0&id=4f52d72d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52d72d",
  null
  
)

export default component.exports